/**
 * lucide-react v0.241.0 - ISC
 */

import createLucideIcon from '../createLucideIcon.js';

const XCircle = createLucideIcon("XCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
]);

export { XCircle as default };
//# sourceMappingURL=x-circle.js.map
